import type {ReactElement} from 'react';
import type {AiPromptBox, SelectedContextualMenuItems} from '@Components/ai-prompt-box/ai-prompt-box.types';
import type {FooterLeftAction} from '@Components/ai-prompt-box/components/ai-prompt-box-footer-left-actions/ai-prompt-box-footer-left-actions.types';
import type {GenerateIdeasOriginator} from '@Libraries/ai-email-campaign-content-library';
import type {BasePanel} from '@Components/panel/panel.types';

export const AI_GENERATION_PANEL_ID = 'ai-generation-panel';

export interface AiGenerationPanelProps<T> extends BasePanel {
  id: string;
  sessionStorageKey: string;
  initialConfig: AiPromptBox;
  fetchRecents: () => Promise<T[]>;
  onGenerate: (prompt: string, options: SelectedContextualMenuItems, originator: GenerateIdeasOriginator) => Promise<T[]>;
  onItemSelect: (item: T, prompt: string) => void;
  getItemKey: (item: T) => string;
  options: FooterLeftAction[];
  renderItem?: (item: T) => ReactElement;
  aiPromptBoxPreviewText?: string;
  showRetryOnError?: boolean;
  closeOnItemSelect?: boolean;
  title: string;
  showBackButton?: boolean;
  onClose?: () => void;
  isMobile?: boolean;
}
